import React from "react";

const MoreInfo = (props) => {
  const { setIsFormOpen } = props;
  return (
    <div className="virtual-events-more-info container">
      <div className="virtual-events-more-info__wrapper">
        <h2 className="virtual-events-more-info__title">
          Need more information?
        </h2>
        <p className="virtual-events-more-info__copy">
          Complete our enquiry form to get in touch with our virtual event
          experts or email kate@venuescanner.com
        </p>
        <button
          className="button button--light"
          onClick={() => setIsFormOpen(true)}
          data-ga={`virtual_events_get-in-touch`}
        >
          Get in touch
        </button>
        <span
          className="virtual-events-more-info__bg virtual-events-more-info__bg--left"
          style={{
            backgroundImage:
              "url(https://s3.eu-west-2.amazonaws.com/venue.scanner/img/virtual-events/more_info_bg-left.png)",
          }}
        />
        <span
          className="virtual-events-more-info__bg virtual-events-more-info__bg--right"
          style={{
            backgroundImage:
              "url(https://s3.eu-west-2.amazonaws.com/venue.scanner/img/virtual-events/more_info_bg-right.png)",
          }}
        />
      </div>
    </div>
  );
};

export default MoreInfo;
